export default __webpack_public_path__ + "static/media/map-mobile.6e4dd086.png";